import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { fetchApi } from "../../utlis/axios";
import { useSelector } from "react-redux";
import { Chart, registerables } from "chart.js";

import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";

Chart.register(...registerables);

const RegisteredFamilyChart = () => {
  const [family, setFamily] = useState([]);
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [refreshing, setRefreshing]=useState(false)

  const getFamilyData = async () => {
    try {
      const result = await fetchApi.get("family-graph/", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });

      if (result.status === 200) {
        const familyDataResponse = result.data;
        const monthlyRegister = {};
        const currentYear = new Date().getFullYear();

        familyDataResponse.forEach((register) => {
          const createdDate = new Date(register.created_at);
          const registerYear = createdDate.getFullYear();

          if (registerYear === currentYear) {
            const month = createdDate.toLocaleString("en-US", {
              month: "long",
            });

            if (monthlyRegister[month]) {
              monthlyRegister[month]++;
            } else {
              monthlyRegister[month] = 1;
            }
          }
        });

        const allMonths = Array.from({ length: 12 }, (_, i) => {
          const monthName = new Date(currentYear, i).toLocaleString("en-US", {
            month: "long",
          });
          return {
            month: monthName,
            totalRegisrer: monthlyRegister[monthName] || 0,
          };
        });

        setFamily(allMonths);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getFamilyData();
  }, []);

  async function handleRefresh(params) {
    setRefreshing(true)
    await getFamilyData()
    setRefreshing(false)
  }

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const data = {
    labels: family.slice(0, currentMonth)?.map((label) => label?.month),
    datasets: [
      {
        label: "Families Registered",
        data: family
          .slice(0, currentMonth)
          ?.map((label) => label?.totalRegisrer),
        backgroundColor: "#0EA5A4",
        borderWidth: 0,
      },
    ],
  };

  const options = {
    scales: {
      x: [
        {
          type: "category",
          grid: {
            display: false,
          },
        },
      ],
      y: [
        {
          beginAtZero: true,
        },
      ],
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,        
          usePointStyle: false,
          boxHeight: 15,   
          padding: 10,
          color: "#000",
          font: { 
            size: 15, 
            weight: "700",
            family: "'Plus Jakarta Sans', sans-serif"       
          },
        },
      },
      
    },
  };

  return (
    <div className="md:mt-6 mt-4 bg-white rounded-xl shadow sm:p-5 p-2.5">
    <div className="dashboardCard">
        <div className="flex items-center justify-between gap-2">
          <p style={{ color: "black", fontSize: "20px" }}>
            Registered Families
          </p>
          <span
          onClick={handleRefresh}
          disabled={refreshing}
          className={`p-2 w-max rounded-lg cursor-pointer !border-[2px] !border-[#D8D8D8] hover:bg-gray-50 transition bg-transparent shadow-none `}
        >
          <FiRefreshCcw
            className={`text-gray-600 text-lg ${
              refreshing ? "animate-spin" : ""
            }`}
          />
        </span>
        </div>
        <Link to="/familydetailpage">
    <div className="family-registration-chart dashboard-responsive">
      <Bar data={data} options={options} height={430} />
    </div>
    </Link>
    </div>
    </div>
  );
};

export default RegisteredFamilyChart;
